<div class="flex flex-col h-full">
  @if (isGuest) {
    <div class="w-auto mx-4 flex flex-col items-center justify-center">
    <vw-icon-svg iconUrl="/assets/images/willy/willy_busy.png" additionalClasses="w-auto h-72"></vw-icon-svg>
    <div class="flex flex-col gap-2 rounded-3xl grow p-4 mx-6 bg-grey-100 h-min relative">
      <div class="absolute -top-10 size-12 left-[10%] rotate-180 z-0 flex justify-end">
        <svg width="100%" height="100%" viewBox="0 0 100 100">
          <path d="M40 0 L100 0 L0 100 Z" fill="#F0EFEF" />
        </svg>
      </div>
      <h2 class="text-grey-700 text-lg">
        {{ "willy.guest.title" | translate }}
      </h2>
      <p class="text-grey-700 text-sm">
        {{ "willy.guest.p1" | translate }}
      </p>
      <ul class="text-sm list-disc list-inside pl-4 text-grey-700">
        <li>
          {{ "willy.guest.p2" | translate }}
        </li>
        <li>
          {{ "willy.guest.p3" | translate }}
        </li>
        <li>
          {{ "willy.guest.p4" | translate }}
        </li>
        <li>
          {{ "willy.guest.p5" | translate }}
        </li>
      </ul>
    </div>
    </div>
  }
  @if (!isGuest) {
    <vw-ai-chatbot-header></vw-ai-chatbot-header>
  }
  @if (!isGuest) {
    <div class="relative h-full pb-20 overflow-y-hidden">
      <vw-ai-chatbot-message [message]="currentMessage" class="h-full"></vw-ai-chatbot-message>
      <div class="absolute bottom-0 left-4 right-0 flex z-20 ">
        <vw-ai-chatbot-willy [action]="willyAction"></vw-ai-chatbot-willy>
      </div>
    </div>
  }
  @if (!isGuest) {
    <div class="bg-white shrink-0 shadow-[0px_-5px_20px_rgba(38,41,57,0.12)] py-4 relative z-[999]">
      <vw-ai-chatbot-input-message (messageSubmitted)="sendMessageToWilly($event)" (inputFocus)="onInputFocus()"
        (inputBlur)="onInputBlur()"></vw-ai-chatbot-input-message>
    </div>
  }
</div>